import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { pick } from 'lodash';
import { Typography,Checkbox } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import {useTranslation} from 'react-i18next';

const validationSchema = Yup.object({
  agent_id: Yup.string().required('Agent is required'),
  commission_type: Yup.string().required('Commission type is required'),
  commission_amount: Yup.number().required('commission amount is required')
});


const AgentCommissionRateModal = ({ billing_exists,edited,open, handleClose, agentsOptions = [], onSave, selectedCommissionMatrix }) => {
  


  const initialValues = {
    agent_id: selectedCommissionMatrix ? selectedCommissionMatrix?.agent_id : null,
    commission_type: selectedCommissionMatrix ? selectedCommissionMatrix?.commission_type : '',
    commission_amount: selectedCommissionMatrix ? selectedCommissionMatrix?.commission_amount : '',
    retroactive_agent_commission: false,
    retroactive_agent_commission_edit:false
  }

  const onClose = () => {
    formik.setValues({
      agent_id: '',
      commission_type: '',
      commission_amount: '',
      retroactive_agent_commission: false,
      retroactive_agent_commission_edit:false
    })
    handleClose();
  }
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: values => {
      onSave(values)
      handleClose()
    }
  });
  const {t} = useTranslation('navigation');

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('AGENT_COMMISSIONS_RATE')}</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <div style={{ marginBottom: '16px', paddingTop: '8px'}}>
            <Autocomplete
              disabled={selectedCommissionMatrix ? true : false}
              options={agentsOptions}
              getOptionDisabled={(option) => option.disabled}
              getOptionLabel={(option) => option.label}
              value={agentsOptions.length ? agentsOptions.find(i => i.value === formik?.values?.agent_id) : ''}
              onChange={(event, _value) => formik.setFieldValue('agent_id', _value.value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('AGENT')}
                  variant="outlined"
                  error={formik.touched.agent_id && Boolean(formik.errors.agent_id)}
                  helperText={formik.touched.agent_id && formik.errors.agent_id}
                />
              )}
            />
          </div>
          <div className='flex flex-col md:flex-row mb-8'>
            <div className='mr-2 mt-8'>
              <Select
                name="commission_type"
                size='small'
                value={formik.values.commission_type}
                onChange={formik.handleChange}
                displayEmpty
                error={formik.touched.commission_type && Boolean(formik.errors.commission_type)}
                fullWidth
              >
                <MenuItem value="" disabled>{t('SELECT_COMMISSION_TYPE')}</MenuItem>
                <MenuItem value="fixed">{t('FIXED_RATE_PER_COMPLETED_TICKET')}</MenuItem>
                <MenuItem value="percentage">{t('PERCENTAGE_OF_UNIT_INVOICE_VALUE_PER_TICKET')}</MenuItem>
                <MenuItem value="rate per quantiy">{t('FLAT_RATE_TICKET_UNIT_QUANTITY_HUALED')}</MenuItem>
              </Select>
              {formik.touched.commission_type && formik.errors.commission_type && (
                <div style={{ color: 'red', marginTop: '4px' }}>
                  {formik.errors.commission_type}
                </div>
              )}
            </div>
            <div className='ml-2'>
              <TextField
                name="commission_amount"
                label={t('COMMISSION_AMOUNT')}
                type="number"
                size='small'
                value={formik.values.commission_amount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="outlined"
                margin="dense"
                className="customTextField"
                error={formik.touched.commission_amount && Boolean(formik.errors.commission_amount)}
                helperText={formik.touched.commission_amount && formik.errors.commission_amount}
                InputProps={{ shrink: true }}
              />
            </div>
          </div>
          {
            billing_exists == false ? 
            null
            :
            edited ? 
            <div className='flex flex-row items-center justify-start align-center'>
              <Typography fontWeight={'bold'}>{t('RETROACTIVE')}</Typography>
              <Checkbox 
                name='retroactive_agent_commission_edit'
                value={formik.values.retroactive_agent_commission_edit}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          :
            <div className='flex flex-row items-center justify-start align-center'>
              <Typography fontWeight={'bold'}>{t('RETROACTIVE')}</Typography>
              <Checkbox 
                name='retroactive_agent_commission'
                value={formik.values.retroactive_agent_commission}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          }
          
          {
            billing_exists == false ? 
            null
            :
            <div className='flex flex-row items-center justify-start align-center'>
              <ReportProblemOutlinedIcon sx={{color: 'red', fontSize:'15px'}} />
              {
                edited ? 
                <div className='flex flex-col justify-start '>
                  <Typography fontWeight={'bold'} color={'red'} >{t('RECALCULATE_ALL_PREVIOUS_COMMISSIONS')}</Typography>
                  <Typography fontWeight={'bold'} color={'red'} >{t('OR_ONLY_GOING_FORWARD')}</Typography>
                </div>
                :
                <div className='flex flex-col justify-start '>
                  <Typography fontWeight={'bold'} color={'red'} >{t('GIVE_COMMISSION_FOR_ALL_TICKETS_IN_THE_JOB')}</Typography>
                  <Typography fontWeight={'bold'} color={'red'} >{t('OR_ONLY_GIVE_COMMISSIONS_GOING_FORWARD')}</Typography>
                </div>
              }
              
            </div> 
          }
          <DialogActions>
            <Button onClick={onClose}>{t('CANCEL')}</Button>
            <Button type="submit" variant='contained' color='primary'>{edited ? t('EDIT'): t('CREATE')}</Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default AgentCommissionRateModal;
